export default __webpack_public_path__ + "static/media/down-arrow.fb97aa9a.svg";